import React, { useContext, useEffect, useState } from 'react';
import { relatesMembersVideo } from '../../Services/allApi';
import './relatedMembers.css';
import { addcontext } from '../../ContextShare/ContextShare';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

function RelatedMembers({ videoData }) {
  const baseUrl = process.env.REACT_APP_BASEURL;
  const { whichPageIsSendingData, setwhichPageIsSendingData } = useContext(addcontext);
  const [relatedMembers, setrelatedMembers] = useState([]);
  const { langChanged } = useContext(addcontext);
  const [currentLanguage, setCurrentLanguage] = useState();
  const [hoveredMemberId, setHoveredMemberId] = useState(null); // To track hover state

  useEffect(() => {
    setCurrentLanguage(localStorage.getItem('language') || 'en');
  }, [currentLanguage, langChanged]);

  const relatedMembersApi = async () => {
    let result;
    if (videoData?.mapping_id) {
      result = await relatesMembersVideo(videoData?.mapping_id);
    }
    setrelatedMembers(result?.data?.data);
  };

  useEffect(() => {
    relatedMembersApi();
  }, [videoData?.mapping_id]);

  return (
    <div className='flex lg:w-3/12 w-11/12 lg:mt-0 mt-6 h-full'>
      <div className='flex flex-col w-full'>
        <div className='flex justify-center mt-2 mb-2 lg:ms-0 ms-8 border-b'>
          <div className='w-10 h-1 bg-primary rounded-xl mb-2'></div>
        </div>
        <div className='w-full h-full overflow-hidden overflow-y-scroll hide-scroll-bar'>
          <div className='flex justify-end flex-col mt-4 lg:ms-0 ms-8'>
            {relatedMembers?.length > 0 ? (
              relatedMembers.map((item) => (
                <div
                  key={item.member_id}
                  className={`relative member-container w-full items-center mb-3 border hover:shadow-xl member-box ${item?.member_name=='-'?'hidden':'flex'}`}
                  style={{ borderRadius: '14px', border: '1px solid #001F33' }}
                  onMouseEnter={() => setHoveredMemberId(item.member_id)}
                  onMouseLeave={() => setHoveredMemberId(null)}
                >
                  <div className='ms-2 me-5 rounded-full flex items-center justify-center w-12 h-12'>
                    <img
                      className='details w-full h-full rounded-full'
                      src={`${baseUrl}${item.member_image}`}
                      alt='profile'
                    />
                  </div>
                  <div className='details flex flex-col'>
                    <div>
                      <p>
                        {currentLanguage === 'en' ? item?.member_name : item?.member_name_malayalam}
                      </p>
                    </div>
                    <div>
                      <p style={{ color: '#878787' }}>
                        {/* {currentLanguage === 'en'
                          ? item?.member_salutation
                          : item?.member_salutation_malayalam} */}
                        {currentLanguage === 'en'
                          ? item?.member_role
                          : item?.member_role_malayalam}
                      </p>
                    </div>
                    {/* Show one or all designations based on hover */}
                    <div className='designations '>
                      {(hoveredMemberId === item.member_id&&item?.designation?.length>1) ? (
                        <>
                        <p className=' text-sm'>Designations</p>
                        <ol>
                          {item?.designation.map((designation, index) => (
                            <li key={index} className=' text-sm' style={{ color: '#878787' }}>
                              {designation}
                            </li>
                          ))}
                        </ol>
                        </>
                      ) : (
                       <>
                        {item?.designation[0]&&<ol>
                        <li className='details text-sm ' style={{ color: '#878787' }}>
                          {item?.designation[0]}
                        </li>
                        </ol>}
                       </>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className='flex flex-col gap-5'>
                <Skeleton height={50} />
                <Skeleton height={50} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RelatedMembers;
